import React from 'react'
import classNames from 'classnames'

import Link from '@components/link'
import styles from '@components/blocks/entry_point_card_list.module.scss'
import entryPointStyles from '@components/blocks/entry_point.module.scss'

const EntryPointCardList = React.forwardRef(({ fields: { title, subtitle, entryPoints } }, _) => (
  <div className={styles.entry_point_card_list}>
    <div className={styles.entry_point_card_list__header}>
      <h3 className={styles.entry_point_card_list__title}>{title}</h3>
      <div className={styles.entry_point_card_list__subtitle}>{subtitle}</div>
    </div>
    <div className={styles.entry_point_card_list__cards}>
      {entryPoints.map((entryPoint, index) => (
        <EntryPointCard key={index} fields={entryPoint.fields} />
      ))}
    </div>
  </div>
))

const EntryPointCard = ({
  fields: { headerImage, title, subtitle, requirements, cta, themeColor },
}) => {
  const headerStyle = { backgroundImage: `url(${headerImage.fields.file.url}?fm=jpg&q=85&h=80)` }

  const linkClasses = [entryPointStyles.entry_point__cta]
  switch (themeColor) {
    case 'Blue':
      linkClasses.push(entryPointStyles['entry_point__cta--blue'])
      break
    case 'Green':
      linkClasses.push(entryPointStyles['entry_point__cta--green'])
      break
    case 'Red':
      linkClasses.push(entryPointStyles['entry_point__cta--red'])
      break
    case 'Purple':
      linkClasses.push(entryPointStyles['entry_point__cta--purple'])
      break
    default:
      break
  }

  return (
    <div className={styles.entry_point_card}>
      <div className={styles.entry_point_card__header_image} style={headerStyle} />
      <div className={styles.entry_point_card__content}>
        <div className={styles.entry_point_card__title}>{title}</div>
        <div className={styles.entry_point_card__subtitle}>{subtitle}</div>
        <div className={styles.entry_point_card__requirements}>{requirements}</div>
        <div className={styles.entry_point_card__cta_container}>
          <Link
            path={cta.fields.ctaPath}
            className={classNames(linkClasses)}
            data-link-type="cta"
            data-link-name={cta.fields.ctaText}
          >
            {cta.fields.ctaText}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default EntryPointCardList
